var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_2726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66672 14.5449C3.06844 14.6666 3.61103 14.6666 4.53337 14.6666H11.4667C12.389 14.6666 12.9316 14.6666 13.3334 14.5449M2.66672 14.5449C2.58059 14.5188 2.50093 14.4871 2.42539 14.4487C2.04907 14.2569 1.74311 13.951 1.55136 13.5746C1.33337 13.1468 1.33337 12.5868 1.33337 11.4666V4.53331C1.33337 3.41321 1.33337 2.85316 1.55136 2.42533C1.74311 2.04901 2.04907 1.74305 2.42539 1.5513C2.85322 1.33331 3.41327 1.33331 4.53337 1.33331H11.4667C12.5868 1.33331 13.1469 1.33331 13.5747 1.5513C13.951 1.74305 14.257 2.04901 14.4487 2.42533C14.6667 2.85316 14.6667 3.41321 14.6667 4.53331V11.4666C14.6667 12.5868 14.6667 13.1468 14.4487 13.5746C14.257 13.951 13.951 14.2569 13.5747 14.4487C13.4992 14.4871 13.4195 14.5188 13.3334 14.5449M2.66672 14.5449C2.66694 14.0054 2.67018 13.7199 2.71795 13.4797C2.92836 12.4219 3.75529 11.595 4.81313 11.3846C5.07073 11.3333 5.3805 11.3333 6.00004 11.3333H10C10.6196 11.3333 10.9294 11.3333 11.1869 11.3846C12.2448 11.595 13.0717 12.4219 13.2821 13.4797C13.3299 13.7199 13.3331 14.0054 13.3334 14.5449M10.6667 6.33331C10.6667 7.80607 9.4728 8.99998 8.00004 8.99998C6.52728 8.99998 5.33337 7.80607 5.33337 6.33331C5.33337 4.86055 6.52728 3.66665 8.00004 3.66665C9.4728 3.66665 10.6667 4.86055 10.6667 6.33331Z",
    stroke: "#CAD5E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_2726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserBox);
export default __webpack_public_path__ + "static/media/ic_user_box.2cb58b074d77a2d60cdcae13e6104993.svg";
export { ForwardRef as ReactComponent };